export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    // Convert to numbers in case they come as strings from API
    const lat1Num = parseFloat(lat1);
    const lon1Num = parseFloat(lon1);
    const lat2Num = parseFloat(lat2);
    const lon2Num = parseFloat(lon2);
    if (
      Number.isNaN(lat1Num) ||
      Number.isNaN(lon1Num) ||
      Number.isNaN(lat2Num) ||
      Number.isNaN(lon2Num)
    ) {
      return null;
    }

    const R = 6371; // Earth's radius in km
    const dLat = ((lat2Num - lat1Num) * Math.PI) / 180;
    const dLon = ((lon2Num - lon1Num) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1Num * Math.PI) / 180) *
        Math.cos((lat2Num * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c).toFixed(2);
};